<template>
  <div class="main-container grid grid-cols-12 row-gap-10 md:col-gap-10">
    <template v-if="loading">
      <div class="h-40 col-span-12 flex flex-col justify-center items-center">
        <p>Confirming that the interview took place.</p>
        <loading-icon class="w-10 h-10 text-pink-500" />
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "ConfirmHappened",
  data() {
    return {
      loading: true
    };
  },
  created() {
    this.confirmHappened(this.$route.params.bookingId);
  },

  methods: {
    async confirmHappened(id) {
      try {
        await this.$store.dispatch("dashboard/bookings/confirmHappened", id);
        this.$router.push({ name: "Activity", params: { bookingId: id } });
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
